export default __webpack_public_path__ + "static/media/Website Privacy Policy.608a0554.pdf";